import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=919920897971"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        backgroundColor: "#ffffff",
        color: "#000",
        padding: "10px 20px",
        borderRadius: "30px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        fontSize: "18px",
        fontWeight: "bold",
        textDecoration: "none",
        zIndex: "1000",
      }}
    >
      <FaWhatsapp color="#25D366" size={24} />
      CHAT
    </a>
  );
};

export default WhatsAppButton;
